import React from 'react';
import { useIntl } from 'umi';
import MultipleSelector, { MulSelectorProps, SelectOptionWithGroup } from './MultipleSelector';
import './index.scss';

const GAME_TYPES_MAPPING: {
  [key: string]: IGameType;
} = {
  MOBILE: 'mobile',
  PC: 'pc',
  CONSOLE: 'console',
};

export const GAME_TYPES: IGameType[] = [GAME_TYPES_MAPPING.MOBILE, GAME_TYPES_MAPPING.PC, GAME_TYPES_MAPPING.CONSOLE];

type IGameType = 'mobile' | 'pc' | 'console' | (string & {});

interface IGameTypeSelectorProps extends MulSelectorProps {
  value: string[];
  onConfirm: (payload: string[]) => void;
}

export default function GameTypeSelector(props: IGameTypeSelectorProps) {
  const { formatMessage } = useIntl();

  const { value: valueOuter, onConfirm } = props;

  const value = Array.isArray(valueOuter) ? valueOuter : [];

  const gameTypesNamesMapping: {
    [key: string]: string;
  } = {
    [GAME_TYPES_MAPPING.MOBILE]: formatMessage({ id: 'dbi_mobile' }),
    [GAME_TYPES_MAPPING.PC]: formatMessage({ id: 'dbi_pc' }),
    [GAME_TYPES_MAPPING.CONSOLE]: formatMessage({ id: 'dbi_console' }),
  };

  const gameTypesOptions: SelectOptionWithGroup[] = GAME_TYPES.map((item) => ({
    text: gameTypesNamesMapping[item],
    value: item,
  }));

  const handleGameTypesChange = (payload: string[]) => {
    const sortedGameTypes = payload?.sort((a, b) => {
      const aIdx = GAME_TYPES.findIndex((item) => item === a);
      const bIdx = GAME_TYPES.findIndex((item) => item === b);
      return aIdx - bIdx;
    });
    onConfirm(sortedGameTypes);
  };

  return (
    <MultipleSelector
      hasAllCheck
      className="dbi-common-game-type-select"
      buttonName={formatMessage({ id: 'dbi_company_game_type' })}
      num={3}
      options={gameTypesOptions}
      value={value}
      onChange={handleGameTypesChange}
    />
  );
}
